// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1YRSH","right":"styles_right__2rzbU"};